<div
  [id]="htmlId()"
  [ngClass]="[properties.style.toLowerCase(), 'preserve-newlines']"
  [style.display]="isVisible() ? 'block' : 'none'">
  {{ properties.text }}
</div>
